import type { WorkbookLiveModeState } from 'cadenza/workbook/state/workbook-live-mode.state';

export function createInitialLiveModeState(): WorkbookLiveModeState {
  return {
    liveModeState: {
      state: 'stopped',
      silent: true,
    },
    liveModeRefreshEvents: [],
  };
}
